export default "__VITE_ASSET__g5V_s17___"